const selfSelector = (state) => state.currencySocket

export default selfSelector
